<script>
    export let selectedItem = null;
    // export let mapImage = null;
    let address = selectedItem["address"] ?? {};
    let street = address["street"];
    let city = address["city"];
    let state = address["state"];
    let zip = address["zip"];

    // TODO: Add a lookup address <a> tag (like forgot password)
    // https://developer.apple.com/documentation/mapkitjs/mapkit/geocoder/2973886-reverselookup
    // Magnifier over map: https://www.w3schools.com/howto/howto_js_image_magnifier_glass.asp
    // TODO: Put the map image in the background of a div: https://www.w3schools.com/howto/howto_css_hero_image.asp
</script>

<div class="edit-container" id="edit-address-loc">
    <div class="edit-section-title">Location & Address</div>
    <form class="edit-form-inline">
        <div class="edit-col" id="edit-address-col">
            <label class="edit-label" for="txtStreet">Street</label>
            <input
                class="edit-input"
                placeholder=""
                type="text"
                bind:this={street}
                name="txtStreet"
            />
            <label class="edit-label" for="txtCity">City</label>
            <input
                class="edit-input"
                placeholder=""
                type="text"
                bind:this={city}
                name="txtCity"
                autocomplete="off"
            />
            <div id="edit-form-inline">
                <div class="edit-col" id="edit-state-col">
                    <label class="edit-label" for="txtState">State</label>
                    <input
                        class="edit-input"
                        placeholder=""
                        type="text"
                        bind:this={state}
                        name="txtState"
                        autocomplete="off"
                    />
                </div>
                <div class="edit-col" id="edit-zip-col">
                    <label class="edit-label" for="txtZip">Zip Code</label>
                    <input
                        class="edit-input"
                        placeholder=""
                        type="text"
                        bind:this={zip}
                        name="txtZip"
                        autocomplete="off"
                    />
                </div>
            </div>
        </div>
        <div class="edit-col" id="edit-map-col">Hello Map</div>
    </form>
</div>

<style>
    #edit-address-loc {
        background-color: #eee;
    }
    #edit-address-col {
        width: 42%;
    }
    #edit-map-col {
        padding: 88px 0;
        background-color: lightgreen;
    }
    /* #edit-state-zip {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    } */
    #edit-state-col,
    #edit-zip-col {
        padding: 0;
    }
</style>
